// Centralized time range configuration
// This file defines all available time ranges and preset configurations

// Base time range definitions
export const TIME_RANGES = [
  { section: 'Minutes', ranges: [
    { value: '5m', label: 'Last 5 minutes', display: 'Last 5 minutes' },
    { value: '15m', label: 'Last 15 minutes', display: 'Last 15 minutes' },
    { value: '30m', label: 'Last 30 minutes', display: 'Last 30 minutes' }
  ]},
  { section: 'Hours', ranges: [
    { value: '1h', label: 'Last 1 hour', display: 'Last 1 hour' },
    { value: '3h', label: 'Last 3 hours', display: 'Last 3 hours' },
    { value: '6h', label: 'Last 6 hours', display: 'Last 6 hours' },
    { value: '12h', label: 'Last 12 hours', display: 'Last 12 hours' },
    { value: '24h', label: 'Last 24 hours', display: 'Last 24 hours' }
  ]},
  { section: 'Days', ranges: [
    { value: '2d', label: 'Last 2 days', display: 'Last 2 days' },
    { value: '7d', label: 'Last 7 days', display: 'Last 7 days' },
    { value: '14d', label: 'Last 14 days', display: 'Last 14 days' },
    { value: '30d', label: 'Last 30 days', display: 'Last 30 days' },
    { value: '90d', label: 'Last 90 days', display: 'Last 90 days' }
  ]}
];

// Preset configurations for different contexts
export const TIME_RANGE_PRESETS = {
  // Full configuration - shows all time ranges with sections
  full: {
    allowedRanges: null, // null means show all
    showCustomRange: true,
    rangeMap: {},
    maxRange: 90
  },

  // Aggregate view configuration - simplified ranges without sections
  aggregate: {
    allowedRanges: ['24h', '7d', '14d', '30d'],
    showCustomRange: false,
    rangeMap: { 
      '24h': '1d', 
      '7d': '7d', 
      '14d': '14d', 
      '30d': '30d' 
    },
    maxRange: 30
  },

  // Device view configuration - simplified ranges with custom option
  device: {
    allowedRanges: ['24h', '7d', '14d', '30d'],
    showCustomRange: true,
    rangeMap: { 
      '24h': '1d', 
      '7d': '7d', 
      '14d': '14d', 
      '30d': '30d' 
    },
    maxRange: 90
  },

  // Reports configuration - extended range for detailed analysis
  reports: {
    allowedRanges: ['1h', '6h', '24h', '7d', '14d', '30d', '90d'],
    showCustomRange: true,
    rangeMap: { 
      '24h': '1d' 
    },
    maxRange: 90
  }
};

// Helper function to get preset configuration
export const getTimeRangePreset = (presetName) => {
  const preset = TIME_RANGE_PRESETS[presetName];
  if (!preset) {
    console.warn(`Unknown time range preset: ${presetName}. Using 'full' preset.`);
    return TIME_RANGE_PRESETS.full;
  }
  return preset;
};

// Helper function to get available ranges for a preset
export const getAvailableRanges = (presetName) => {
  const preset = getTimeRangePreset(presetName);
  
  if (!preset.allowedRanges) {
    return TIME_RANGES; // Return all ranges with sections
  }

  // Create flat list for restricted presets
  const flatRanges = [];
  TIME_RANGES.forEach(section => {
    section.ranges.forEach(range => {
      if (preset.allowedRanges.includes(range.value)) {
        flatRanges.push(range);
      }
    });
  });
  
  return [{ section: '', ranges: flatRanges }];
};

// Default preset
export const DEFAULT_PRESET = 'full';
